import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const exchangeRateApi = createApi({
  reducerPath: 'exchangeRateApi',
  baseQuery,
  endpoints: (builder) => ({
    getExchangeRate: builder.query<number, void>({
      query: () => ({
        url: `/api/exchangerates`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetExchangeRateQuery } = exchangeRateApi;
